import * as React from 'react';
import withStyles from 'react-jss';
import { WarningTwoTone, ScanOutlined } from '@ant-design/icons';
import { useTheme } from 'react-jss';

import { CssType, ThemeType } from '@theming/jssTypes';
import { humanize } from '@utils/utils';
import Modal from 'src/design-system/components/atoms/Modal/Modal';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
import Button from 'src/design-system/components/atoms/Button/Button';

const styles = (theme: ThemeType): CssType => ({
  failureModal: {
    padding: `${theme.spacing[8]} 0`,
  },
  continueModal: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  failureTable: {
    padding: `${theme.spacing[4]} ${theme.spacing[0]}`,
    marginLeft: theme.spacing[0],
  },
  customPrimaryButton: {
    backgroundColor: theme.color.semantic.brand.default.primary,
    color: theme.color.semantic.text.inverse,
  },
  warningIcon: {
    fontSize: theme.typography.fontSize.lg,
  },
});

const defaultColumns = [
  {
    title: 'S. No',
    dataIndex: 'serial_number',
  },
  {
    title: 'Piece Reference No.',
    dataIndex: 'reference_number',
  },
];

const ScanErrorModal = (props) => {
  const { columns = defaultColumns, data, isVisible, classes, width } = props;
  const theme: any = useTheme();

  const generateColumnForTable = () => {
    const columnData: any = [];
    if (!data || data.length === 0) {
      return columnData;
    }
    const indexList = columns;
    indexList.forEach((item) => {
      const itemToPush: any = {};
      itemToPush['title'] = item.title;
      itemToPush['dataIndex'] = item.dataIndex;
      itemToPush['key'] = item.dataIndex;
      itemToPush['width'] = item.dataIndex === 'serial_number' ? 80 : 150;
      if (item.dataIndex === 'serial_number') {
        itemToPush['render'] = (text, record, index) => index + 1;
      } else {
        itemToPush['render'] = (text, record, index) => {
          return typeof record[item.dataIndex] !== 'string'
            ? text
            : record[item.dataIndex]
            ? humanize(record[item.dataIndex])
            : null;
        };
      }

      columnData.push(itemToPush);
    });

    return columnData;
  };

  const handleModalClose = () => {
    props.onModalClose();
  };

  return (
    <Modal
      title={
        <div>
          <WarningTwoTone twoToneColor={theme.color.semantic.brand.danger.primary} className={classes.warningIcon} />{' '}
          Errors
        </div>
      }
      className={classes.failureModal}
      visible={isVisible}
      onCancel={handleModalClose}
      destroyOnClose
      maskClosable={false}
      width={width || 300}
      okText="Ok"
      footer={null}
      closable={false}
    >
      <div>
        <div>
          The following <b>pieces are missing</b>. Please complete scan to
          proceed
        </div>
        <FixedHeaderTable
          className={classes.failureTable}
          pagination={false}
          scroll={{ y: '400px' }}
          columns={generateColumnForTable()}
          dataSource={data}
          rowKey={(record) => record['reference_number']}
          minHeight={200}
        />
        <Button
          className={classes.continueModal}
          onClick={handleModalClose}
          type="primary"
          icon={<ScanOutlined />}
        >
          Continue to Scan
        </Button>
      </div>
    </Modal>
  );
};

const StyledScanErrorModal = withStyles(styles, { injectTheme: true })(
  ScanErrorModal,
);
export default StyledScanErrorModal;
